import { TOAST_DURATION } from '@/constants'
import LayoutBasic from '@/components/LayoutBasic/LayoutBasic.vue'
import { mapGetters } from 'vuex'
import { JSConn } from '@/utilities/js-conn.js'

export default {
  name: 'IrrigationList',
  components: {
    LayoutBasic
  },
  data () {
    return {
      isPaginated: true,
      isPaginationSimple: false,
      defaultSortDirection: 'asc',
      currentPage: 1,
      perPage: 25
    }
  },
  computed: {
    ...mapGetters([
      'irrigationItemsList'
    ])
  },
  methods: {
    deleteIrrigationItem (id) {
      const jsConn = new JSConn()
      jsConn.toRoutePath = '/irrigation'
      jsConn.formParams = {
        id: id
      }
      this.$store.dispatch('deleteIrrigationItem', jsConn)
        .then((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-success',
            duration: TOAST_DURATION
          })
        })
        .catch((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-warning',
            duration: TOAST_DURATION
          })
        })
    }
  }
}
